import {graphql, useStaticQuery} from "gatsby";
import {BRANDS} from "../common";

export const useInternalPaths = () => {
  const {
    pages: { nodes },
  } = useStaticQuery(graphql`
      {
        pages: allSitePage {
          nodes {
            path
          }
        }
      }
    `)

  // Массив из элементов url path лендингов нового типа
  const newLandingUrls = nodes.map(node => {
    const nodePath = node.path;
    const pathPartsArr = nodePath.split('/');
    if (pathPartsArr.length > 4) {
      return nodePath
    }
  }).filter(Boolean);

  // Промежуточный массив из названий лендингов
  const landingNames = newLandingUrls.map(item => {
    const pathPartsArr = item.split('/');
    const landingName = pathPartsArr[pathPartsArr.length - 2];
    const brand = BRANDS[pathPartsArr[1]];

    if (item && landingName && BRANDS[brand]) {
      return landingName
    }
  }).filter(Boolean);

  // Массив уникальных названий лендингов
  const uniqueLandingNames = [...new Set(landingNames)];

  // Массив с объектами всех отдельных страниц
  const landingsArr = newLandingUrls.map(path => {
    const pathPartsArr = path.split('/');
    const landingName = pathPartsArr[pathPartsArr.length - 2];
    const brand = BRANDS[pathPartsArr[1]];
    const lang = pathPartsArr[2];

    if (path && BRANDS[brand]) {

      const result = {
        path,
        [landingName]: {
          [brand]: {
            langs: [lang]
          }
        }
      }

      return result
    }
  }).filter(Boolean);

  // Массив с объектами лендингов по названию
  const result = uniqueLandingNames.map(element => {
    const filteredLandings = landingsArr.filter(item => item[element]);

    const combinedByLandingName = filteredLandings.reduce((acc, record) => {
      const path = record.path;
      const pathPartsArr = path.split('/');
      const brand = BRANDS[pathPartsArr[1]];
      const lang = pathPartsArr[2];

      if (!acc[element]) acc[element] = { [brand]: { langs: []} };

      acc[element][brand] = acc[element][brand] || {langs: []};

      const langsArr = acc[element][brand];

      acc[element][brand] = { langs: [...langsArr.langs, lang] }

      return acc;
    }, {});

    return combinedByLandingName
  })

  return result
}